<template>
  <div class="timeline-issue">
    <ul>
      <li class="timeline-issue-date">
        <label>Leída:{{ getDateString(issue.timeline.leida_en)}}</label>
      </li>
      <li class="timeline-issue-date">
        <label>En Progreso:{{ getDateString(issue.timeline.en_progreso_en)}}</label>
      </li>
      <li class="timeline-issue-date">
        <label>Resuelta:{{ getDateString(issue.timeline.resuelta_en)}}</label>
      </li>
    </ul>
  </div>
</template>
<script>
import { apiServer, staticServer, florette_web } from "@/globalVars.js";

export default {
  name: "issue-time-line",
  components: {},
  props: {
    issue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    getDateString(value) {
      if (value != null) {
        let d = new Date(value);
        return d.toLocaleString("es-ES", { timeZone: "Europe/Madrid" });
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-issue ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.timeline-issue-date {
  margin-top: 10px;
}
.state-label {
  font-size: 1.5em !important;
  padding-top: 15px;
  padding-right: 5px;
}
</style>


